import { render, staticRenderFns } from "./mapRegister.vue?vue&type=template&id=6bca9c67&scoped=true"
import script from "./mapRegister.vue?vue&type=script&lang=js"
export * from "./mapRegister.vue?vue&type=script&lang=js"
import style0 from "./mapRegister.vue?vue&type=style&index=0&id=6bca9c67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca9c67",
  null
  
)

export default component.exports